// ./src/components/features/CalendarViewSelector/CalendarViewSelector.tsx
import React, { useEffect } from "react";
import { Select, SelectProps } from "@mantine/core";

const CALENDAR_VIEW_OPTIONS = [
  { value: "month", label: "Month", disabled: false },
  { value: "week", label: "Week", disabled: false },
];

export interface CalendarViewSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current status value (100 for enabled, 0 for disabled) */
  value: string | null | undefined;

  /** Callback when status changes */
  onChange: (value: string | null | undefined) => void;

  required?: boolean;
}

export const CalendarViewSelector: React.FC<CalendarViewSelectorProps> = ({
  value,
  onChange,
  required,
  placeholder = "Select display type",
  ...selectProps
}) => {
  // Convert numeric value to string for Select component
  const stringValue = value !== null ? String(value) : null;

  // Prepare select data with optional descriptions
  const selectData = CALENDAR_VIEW_OPTIONS.map((option: any) => {
    let label: string = option.label;

    return {
      value: option.value,
      label,
      disabled: option.disabled,
    };
  });

  // Auto-select first display type if required and no value is set
  useEffect(() => {
    if (required && !value && onChange) {
      const firstOption = CALENDAR_VIEW_OPTIONS[0];
      if (firstOption && !firstOption.disabled) {
        onChange(firstOption.value);
      }
    }
  }, [required, value, onChange]);

  // Handle change and convert back to number
  const handleChange = (stringValue: string | null) => {
    if (stringValue === null) {
      onChange(null);
    } else {
      onChange(stringValue);
    }
  };

  return (
    <Select
      {...selectProps}
      data={selectData}
      value={stringValue}
      onChange={handleChange}
      placeholder={placeholder}
      clearable={!required}
      required={required}
      allowDeselect={!required}
      withAsterisk={required}
    />
  );
};

// Export status options for use in other components
export { CALENDAR_VIEW_OPTIONS };
